// extracted by mini-css-extract-plugin
export default {"editButton":"InsightEdit_editButton__2K2iJ","sparkleIcon":"InsightEdit_sparkleIcon__POc3d"};